// Anchors the checkout countdown to the client's own clock using the
// server-provided remaining duration (seconds_until_expiry).
//
// Previously the countdown compared an absolute server timestamp
// (ticketReservation.expires_at) against the browser's Date.now(). For buyers
// whose machine clock runs fast by more than the hold window, that comparison
// was already negative on arrival, so the countdown completed instantly and
// released the reservation with "Time Limit Reached" (O-2939).
//
// Driving the timer from a relative duration anchored to Date.now() cancels any
// client/server clock skew: both the target and the comparison use the same
// (client) clock.

export const DEFAULT_CHECKOUT_DURATION_MS = 10 * 60 * 1000;

export const computeCheckoutCountdown = (secondsUntilExpiry, now = Date.now()) => {
  const hasValue =
    typeof secondsUntilExpiry === 'number' && !Number.isNaN(secondsUntilExpiry);

  // Fall back to a full hold window when the server didn't provide a value
  // (e.g. stale cached JS during a deploy). The server-side expiration worker
  // remains the source of truth for the real hold, so a slightly generous
  // client timer here is safe.
  const remainingMs = hasValue
    ? Math.max(secondsUntilExpiry * 1000, 0)
    : DEFAULT_CHECKOUT_DURATION_MS;

  return {
    target: now + remainingMs,
    total: remainingMs > 0 ? remainingMs : 1
  };
};
